import { useEffect, useState} from "react";
import "../css/Favorites.css";

const Favorites = () => {

    const [favorites, setFavorites] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFavorites = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}api/favorites/show`, {
                    method: "GET",
                    headers: {"Content-Type":"application/json"},
                    credentials: "include",
                });

                if(!res.ok){
                    console.error("No favorites found or error getting favorites");
                    setFavorites(null);
                    setLoading(false);
                    return;
                }

                const data = await res.json();
                setFavorites(data);
            }
            catch(err){
                console.error("Error fetching favorites", err);
            }
            finally{
                setLoading(false);
            }
        };
        fetchFavorites();
    }, []);

    if(loading) return <p>Loading favorites...</p>;

    if(!favorites)return(
        <div>
            <h1>Favorites</h1>
            <p>No favorites saved yet.</p>
        </div>
    );

 return (
    <div className="fav-wrap">
      <p className="fav-title">Teams</p>

      {favorites.flatMap(doc => doc.team ? [doc.team] : [])
      .filter(t => t.isFavorite)
      .map((t, i) => (
        <div key={i} className="team-card">
          <img className="team-logo" src={t.logo} alt={t.name} />
          <div className="team-info">
            <p className="team-name">{t.name}</p>
            <span className="team-sport">{t.sport}</span>
          </div>
        </div>
      ))}
        
    <div className="section-gap">
      <p className="fav-title">Players</p>
      <div className="players-grid">
        {favorites.flatMap(doc => doc.players ?? [])
            .filter(p => p.isFavorite)
            .map((p,i) => {
                const [team, number, ...nameParts] = p.name.split("-");
                const name = nameParts.join(" ");
            return (
                <div key={i} className="player-row">
                    <span className="player-number">#{number}</span>
                    <span className="player-name">{name}</span>
                    <span className="player-team">{team}</span>
                </div>
            );
          })}
      </div>
    </div>
  </div>
  );

};

export default Favorites;